module.exports = __webpack_public_path__ + "static/img/img_3.8406fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_3.jpg
// module id = EamE
// module chunks = 0